import * as React from "react"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import { Check } from "lucide-react"

import { cn } from "@/lib/utils"

const Checkbox = React.forwardRef(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      "peer h-5 w-5 shrink-0 rounded-md bg-neu-base shadow-neu-inset-sm border border-white/40 transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-luvcorp-gold/60 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-luvcorp-gold data-[state=checked]:shadow-neu-outset-sm data-[state=checked]:border-luvcorp-gold/40 data-[state=checked]:text-luvcorp-navy",
      className
    )}
    {...props}>
    <CheckboxPrimitive.Indicator className={cn("flex items-center justify-center text-current")}>
      <Check className="h-3.5 w-3.5 stroke-[3]" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
